// tslint:disable:no-empty-interface
import { TeamUser } from '../../auth'

import {
  AppFeedbackDtoSchema,
  ArchiveReviewsListItemDtoSchema,
  AssessmengPatchDtoSchema,
  AssessmentAccessRightsSchema,
  AssessmentDataChangePositionSchema,
  AssessmentDataEndYearSchema,
  AssessmentDataEndYearSchemaNew,
  AssessmentDataExitSchema,
  AssessmentDataLeaveCompanySchema,
  AssessmentDataMidYearSchema,
  AssessmentDataMidYearSchemaNew,
  AssessmentDataOneToOneSchema,
  AssessmentDataProbationSchema,
  AssessmentPostDtoSchema,
  AssessmentPutDtoSchema,
  AssessmentRecordSchema,
  AssessmentWithAccessRightsDtoSchema,
  AssignedPersonDtoSchema,
  CommentGetDtoSchema,
  DevelopmentGoalAccessRightsDtoSchema,
  DevelopmentGoalPostDtoSchema,
  DevelopmentGoalPutDtoSchema,
  DevelopmentGoalWithCommentsDtoSchema,
  DevelopmentRatingGetDtoSchema,
  DevelopmentRatingPutDtoSchema,
  FeedbackGetDtoSchema,
  FeedbackListItemDtoSchema,
  FeedbackListItemEntityDtoSchema,
  FeedbackPostDtoSchema,
  FeedbackRequestGetDtoSchema,
  FeedbackRequestGoalDtoSchema,
  FeedbackRequestListItemEntityDtoSchema,
  FeedbackRequestPersonRequestorDtoSchema,
  FeedbackRequestPostDtoSchema,
  GoalAccessRightsDtoSchema,
  GoalActivityListItemDtoSchema,
  GoalGetDtoSchema,
  GoalOverviewSchema,
  GoalPostDtoSchema,
  GoalPutDtoSchema,
  GoalWithAccessRightsDtoSchema,
  GoalWithCommentsDtoSchema,
  IdpGetDtoSchema,
  IdpPostDtoSchema,
  IdpPutDtoSchema,
  ItemReceiverPersonSchema,
  ManagerTeamGoalsDtoSchema,
  OrderedEmployeeReviewsPutDtoSchema,
  PersonGoalsDtoSchema,
  RatingGetDtoSchema,
  RatingPutDtoSchema,
  ReviewAccessRightsSchema,
  ReviewerPutDtoSchema,
  ReviewFinalScoreSchema,
  ReviewHeaderDtoSchema,
  ReviewHeaderItemDtoSchema,
  ReviewWithAssessmentsGetDtoSchema,
  TeamReviewDevelopmentGoalWithCommentsDtoSchema,
  TeamReviewGetDtoItemSchema,
  TeamReviewGetDtoSchema,
  TeamReviewGoalWithCommentsDtoSchema,
} from '../../../schemas'

import { ApiCollection } from '../../../types'
import { ImageUrls } from '../../shared'

import { GoalType, ReviewType } from './enums'

export * from './comments'
export * from './mappers'
export * from './enums'

export interface SaveNewGoalPayload {
  notSavedGoalId: number
  newGoal: GoalWithAccessRightsDto
}

export interface GoalNewPayload {
  goalId: number
  dto: GoalPostDto
}

export interface GoalUpdatePayload {
  goalId: number
  dto: GoalPutDto
}

export interface ManagerOfGoalUpdatePayload {
  goalId: number
  dto: { newGoalOwnerPersonalId: number }
}

export interface GoalStateChangeDto {
  goalId: number
  newState: number
  goalType: GoalType
}

export interface BonusPeriodDto {
  bonusPeriodId: number
  organizationId: number
  name: string
  validFrom: Date
  validTo: Date
}

export interface BasicUserInfo {
  personId: number
  activePersonInstanceId: number
  organizationUnitId: number
  supervisorPersonId: number

  canCreateGoals: boolean
}

// FIXME: this entity should come from schemas as other entities
export interface TeamGetDto {
  coreTeam: TeamUser[]
  functionalTeam: TeamUser[]
  regionalTeam: TeamUser[]
}

export interface GoalConvertPayload {
  originalTeamGoalId: number
  personId: number
}

export interface GoalConvertSuccessPayload {
  originalTeamGoalId: number
  newGoal: GoalWithAccessRightsDto
}

export interface GoalLinkDto {
  goalLinkId: number
  personId: number
  displayName: string
}

export interface GoalRatingsPayload {
  goalId: number
  ratings: {
    [ratingType: number]: RatingGetDto
  }
}

export interface DevelopmentGoalRatingsPayload {
  goalId: number
  ratings: {
    [ratingType: number]: DevelopmentRatingGetDto
  }
}

export interface AppFeedbackDto extends AppFeedbackDtoSchema {}

export interface FeedbackRequestPostDto extends FeedbackRequestPostDtoSchema {}
export interface FeedbackRequestGetDto extends FeedbackRequestGetDtoSchema {}
export interface FeedbackPostDto extends FeedbackPostDtoSchema {}
export interface FeedbackGetDto extends FeedbackGetDtoSchema {}
export interface FeedbackRequestGoalDto extends FeedbackRequestGoalDtoSchema {}
export interface FeedbackListItemDto extends FeedbackListItemDtoSchema {}
export interface FeedbackListItemEntityDto extends FeedbackListItemEntityDtoSchema {}
export interface FeedbackRequestListItemEntityDto extends FeedbackRequestListItemEntityDtoSchema {}
export interface FeedbackRequestGoalDto extends FeedbackRequestGoalDtoSchema {}
export interface FeedbackRequestPersonRequestorDto extends FeedbackRequestPersonRequestorDtoSchema {}
export type FeedbackRequestGoalPagedData = ApiCollection<FeedbackRequestGoalDto>

export interface ItemReceiverPersonDto extends ItemReceiverPersonSchema {}

export interface CreateFeedbackReplyDto {
  feedbackAssignmentId: number
  receiverComment: string
}
export interface GetFeedbackFilterDto {
  personId: number
  initiationType: ItemInitiationType
}

export enum ItemInitiationType {
  Activity = 1,
  Mentions = 2,
  Archive = 3,
}

export enum AssessmentType {
  Employee = 1,
  Manager = 2,
}

export enum AssessmentState {
  Draft = 0,
  Finished = 5,
  OpenForCalibration = 6,
  Published = 7,
}

export enum ReviewState {
  Active = 1,
  Finished = 7,
}

export interface ValidDatesDto {
  validTo: string
  validFrom: string
}

export interface GoalPostDto extends GoalPostDtoSchema {}
export interface GoalWithAccessRightsDto extends GoalWithAccessRightsDtoSchema {}
export interface GoalPutDto extends GoalPutDtoSchema {}
export interface GoalGetDto extends GoalGetDtoSchema {}
export interface GoalWithCommentsDto extends GoalWithCommentsDtoSchema {
  accessRights: GoalAccessRightsDto
}

export interface TeamReviewGoalWithCommentsDto extends TeamReviewGoalWithCommentsDtoSchema {
  accessRights: GoalAccessRightsDto
}

export interface TeamReviewDevelopmentGoalWithCommentsDto extends TeamReviewDevelopmentGoalWithCommentsDtoSchema {}
export interface PersonGoalsDto extends PersonGoalsDtoSchema {
  goals: GoalWithCommentsDto[]
  teamGoals: GoalWithCommentsDto[]
  developmentGoals: DevelopmentGoalWithCommentsDto[]
}

export interface ManagerTeamGoalsDto extends ManagerTeamGoalsDtoSchema {}

export interface GoalAccessRightsDto extends GoalAccessRightsDtoSchema {}

/* DTO for one comment (comment api, goal api) */
export interface CommentGetDto extends CommentGetDtoSchema {}

export interface GoalActivityListItemDto extends GoalActivityListItemDtoSchema {}

export interface RatingPutDto extends RatingPutDtoSchema {}
export interface RatingGetDto extends RatingGetDtoSchema {}
export interface DevelopmentRatingPutDto extends DevelopmentRatingPutDtoSchema {}
export interface DevelopmentRatingGetDto extends DevelopmentRatingGetDtoSchema {}

/* IDP aka MyDevelopment */
export interface IdpPostDto extends IdpPostDtoSchema {}
export interface IdpPutDto extends IdpPutDtoSchema {}
export interface IdpGetDto extends IdpGetDtoSchema {}

/* Development goals */

export interface DevelopmentGoalPostDto extends DevelopmentGoalPostDtoSchema {}
export interface DevelopmentGoalPutDto extends DevelopmentGoalPutDtoSchema {
  id: number
}
export interface DevelopmentGoalWithCommentsDto extends DevelopmentGoalWithCommentsDtoSchema {
  type?: any
}
export interface DevelopmentGoalAccessRightsDto extends DevelopmentGoalAccessRightsDtoSchema {}

export interface DevGoalUpdatePayload {
  id: number
  dto: DevelopmentGoalPutDto
}

export interface SaveNewDevGoalPayload {
  notSavedId: number
  newGoal: DevelopmentGoalWithCommentsDto
}

/* Reviews */

export interface ReviewAccessRights extends ReviewAccessRightsSchema {}

export interface AssessmentRecord extends AssessmentRecordSchema {
  [key: string]: any
  finalComments?: string
  functionQualityComment?: string
}

export interface AssessmentDataMidYear extends AssessmentDataMidYearSchema {
  hasSecondaryCoreValue: boolean
  [key: string]: any
}

export interface AssessmentDataMidYearNew extends AssessmentDataMidYearSchemaNew {
  [key: string]: any
}

export interface AssessmentDataEndYearNew extends AssessmentDataEndYearSchemaNew {
  [key: string]: any
}

export interface AssessmentDataEndYear extends AssessmentDataEndYearSchema {
  [key: string]: any
}

export interface AssessmentDataChangePosition extends AssessmentDataChangePositionSchema {
  hasSecondaryCoreValue: boolean
  [key: string]: any
}

export interface AssessmentDataLeaveCompany extends AssessmentDataLeaveCompanySchema {
  hasSecondaryCoreValue: boolean
  [key: string]: any
}

export interface AssessmentDataExit extends AssessmentDataExitSchema {
  hasSecondaryCoreValue: boolean
  [key: string]: any
}

export interface AssessmentDataOneToOne extends AssessmentDataOneToOneSchema {
  [key: string]: any
}
export interface AssessmentDataProbation extends AssessmentDataProbationSchema {
  [key: string]: any
}

export interface AssessmentWithAccessRightsDto<TData> extends AssessmentWithAccessRightsDtoSchema<TData> {}

export interface ReviewWithAssessmentsGetDto<TData> extends ReviewWithAssessmentsGetDtoSchema<TData> {
  managerAssessment: AssessmentWithAccessRightsDto<TData>
  employeeAssessment: AssessmentWithAccessRightsDto<TData>
}

export interface ReviewMidYearWithAssessmentsGetDto extends ReviewWithAssessmentsGetDto<AssessmentDataMidYear> {
  goals?: GoalOverview
}

export interface ReviewEndYearWithAssessmentsGetDto extends ReviewWithAssessmentsGetDto<AssessmentDataEndYear> {}

export interface ReviewOneToOneWithAssessmentsGetDto extends ReviewWithAssessmentsGetDto<AssessmentDataOneToOne> {}

export interface ReviewProbationWithAssessmentsGetDto extends ReviewWithAssessmentsGetDto<AssessmentDataProbation> {}

export interface ReviewLeaveCompanyWithAssessmentsGetDto
  extends ReviewWithAssessmentsGetDto<AssessmentDataLeaveCompany> {}

export interface ReviewExitWithAssessmentsGetDto extends ReviewWithAssessmentsGetDto<AssessmentDataExit> {}

export interface ReviewChangePositionWithAssessmentsGetDto
  extends ReviewWithAssessmentsGetDto<AssessmentDataChangePosition> {}

export interface ReviewOneToOneWithPrevious {
  actual: ReviewOneToOneWithAssessmentsGetDto
  previous: ReviewOneToOneWithAssessmentsGetDto | null
}

/* goals overview for end-year review */
export interface GoalOverview extends GoalOverviewSchema {}
/** final rating for end-year */
export interface ReviewFinalScore extends ReviewFinalScoreSchema {}

export interface ReviewerPutDto extends ReviewerPutDtoSchema {}

/* Assessments */

export interface AssessmentAccessRights extends AssessmentAccessRightsSchema {}

export interface AssessmentMidYearWithAccessRightsDto
  extends AssessmentWithAccessRightsDtoSchema<AssessmentDataMidYear> {}

export interface AssessmentEndYearWithAccessRightsDto
  extends AssessmentWithAccessRightsDtoSchema<AssessmentDataEndYear> {}

export interface AssessmentOneToOneWithAccessRightsDto
  extends AssessmentWithAccessRightsDtoSchema<AssessmentDataOneToOne> {}

export interface AssessmentProbationWithAccessRightsDto
  extends AssessmentWithAccessRightsDtoSchema<AssessmentDataProbation> {}

export interface AssessmentLeaveCompanyWithAccessRightsDto
  extends AssessmentWithAccessRightsDtoSchema<AssessmentDataLeaveCompany> {}

export interface AssessmentExitWithAccessRightsDto extends AssessmentWithAccessRightsDtoSchema<AssessmentDataExit> {}

export interface AssessmentChangePositionWithAccessRightsDto
  extends AssessmentWithAccessRightsDtoSchema<AssessmentDataChangePosition> {}

export interface AssignedPersonDto extends AssignedPersonDtoSchema {}

export interface AssessmentPostDto extends AssessmentPostDtoSchema {}

export interface AssessmentPutDto<TData> extends AssessmentPutDtoSchema<TData> {}

export interface AssessmentPatchMidYearDto extends AssessmengPatchDtoSchema<AssessmentDataMidYear> {}
export interface AssessmentPatchEndYearDto extends AssessmengPatchDtoSchema<AssessmentDataEndYear> {}

/* Team reviews */

export interface TeamReviewMidYearGetDto extends TeamReviewGetDtoSchema<AssessmentDataMidYear> {}
export interface TeamReviewEndYearGetDto extends TeamReviewGetDtoSchema<AssessmentDataEndYear> {}
export interface TeamReviewOneToOneGetDto extends TeamReviewGetDtoSchema<AssessmentDataOneToOne> {}
export interface TeamReviewProbationGetDto extends TeamReviewGetDtoSchema<AssessmentDataProbation> {}
export interface TeamReviewLeaveCompanyGetDto extends TeamReviewGetDtoSchema<AssessmentDataLeaveCompany> {}
export interface TeamReviewChangePositionGetDto extends TeamReviewGetDtoSchema<AssessmentDataChangePosition> {}

export interface TeamReviewMidYearGetDtoItem extends TeamReviewGetDtoItemSchema<AssessmentDataMidYear> {
  order: number
  isSaving: boolean
  subordinates: TeamReviewMidYearGetDtoItem[]
}

export interface TeamReviewEndYearGetDtoItem extends TeamReviewGetDtoItemSchema<AssessmentDataEndYear> {
  order: number
  isSaving: boolean
  subordinates: TeamReviewEndYearGetDtoItem[]
}

// export interface AssessmentWithAccessRightsDto extends AssessmentWithAccessRightsDtoSchema {}
// export interface ReviewGetDto extends ReviewGetDtoSchema {}

// export interface TeamReviewGetDtoItem extends TeamReviewGetDtoItemSchema {
//   managerAssessment: AssessmentWithAccessRightsDto
//   isSaving: boolean
//   order: number
//   subordinates: TeamReviewGetDtoItem[]
// }

// export interface TeamReviewGetDto extends TeamReviewGetDtoSchema {}

export interface ArchiveReviewsListItemDto extends ArchiveReviewsListItemDtoSchema {}
export interface OrderedEmployeeReviewsPutDto extends OrderedEmployeeReviewsPutDtoSchema {}

export interface ReviewHeaderDto extends ReviewHeaderDtoSchema {}
export interface ReviewHeaderItemDto extends ReviewHeaderItemDtoSchema {}

export interface AdHocSupervisor {
  id: number
  name: string
  label: string
  imageUrls: ImageUrls
}

export type ShowedReviewsType = Record<number, boolean>

export interface MidYearReviewStoreDto {
  review: ReviewMidYearWithAssessmentsGetDto
  goalOverview: GoalOverview
}

export interface EndYearReviewStoreDto {
  review: ReviewEndYearWithAssessmentsGetDto
  goalOverview: GoalOverview
  linkedMidYear: ReviewMidYearWithAssessmentsGetDto | null
  endYearFinalScore: number
}

export interface ExitReviewStoreDto {
  review: ReviewExitWithAssessmentsGetDto
  goalOverview: GoalOverview
  exitFinalScore: number
}



// WEBPACK FOOTER //
// ./src/app/front-face/models/index.ts